var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftsideone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 529,
    viewBox: "0 0 353 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M62.2576 528.618C-75.4039 528.618 -187 410.367 -187 264.498C-187 118.628 -75.4039 0.376953 62.2576 0.376953C199.919 0.376953 171.321 49.2985 311.515 264.498C451.709 479.697 199.919 528.618 62.2576 528.618Z",
    fill: "#474A88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftsideone);
export default __webpack_public_path__ + "static/media/leftsideone.ecc2412189d3e229e6ef4c10811d37c4.svg";
export { ForwardRef as ReactComponent };